
export default defineNuxtPlugin(nuxtApp => {

  nuxtApp.provide('dpr', window.devicePixelRatio)
  
})